import { SkeletonLoaderModule } from 'src/app/ui-components/skeleton-loader/skeleton-loader.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputBoxModule } from '../input-box/input-box.module';
import { LabelFabModule } from '../label-fab/label-fab.module';
import { SearchWidgetComponent } from './search-widget.component';

@NgModule({
  declarations: [SearchWidgetComponent],
  imports: [CommonModule, InputBoxModule, LabelFabModule, SkeletonLoaderModule],
  exports: [SearchWidgetComponent],
})

export class SearchWidgetModule {
  constructor() {}
}
